import api from "@/api/axios";
export default {
  namespaced: true,
  state: {
    promo_banners: [],
  },
  mutations: {
    SET_BANNERS(state, payload) {
      state.promo_banners = payload;
    },
  },
  actions: {
    async getPromoBanners({ commit }) {
      try {
        commit("setLoading", true, { root: true });
        // const res = await api.get('/admin/promo-banners')
        // const totalPromoBanners = res.data.meta.total

        const reasons = await api.get("/admin/promo-banners");
        commit("SET_BANNERS", reasons.data.data);
        commit("setLoading", false, { root: true });
      } catch (error) {
        // commit('setLoading', false, { root: true })
        return error;
      }
    },
  },
};
